export default __webpack_public_path__ + "0f7795e450bb802bc8e69899fa9bddd7.png";